import * as React from 'react'
import { Box, Typography } from '@mui/material';
import { formatPercentage } from "@ui-seeker/utils";

import { ArrowBackground } from '@components';

export default function percentageColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			customBodyRowRenderLite: (value, { currency,  ...dataRow }) => {
				return <Box sx={{ textAlign: 'center' }}>
				<ArrowBackground
					value={value}
					backgroundColor={value > 0 ? 'success.light' : 'error.light'}
				>
					{formatPercentage(value, { decimals: 2 })}
				</ArrowBackground>
			</Box>
			}
		}
	}
}